module.exports = __webpack_public_path__ + "static/media/9.adb6b683.jpg";